import type { SidebarFolder } from "@/lib/sidebar-folders";
import { apiFetch } from "./client";
import type { SidebarItem } from "@/lib/sidebar-items";
import type { SidebarView } from "@/lib/sidebar-views";
import type { WorkspacePageSummary } from "@/lib/workspace-pages";

/** Навигации дополнительно нужен магазин страницы для цветной точки в списке. */
export type SidebarWorkspacePageSummary = WorkspacePageSummary & {
  store_ref?: string | null;
};

export type SidebarItemsResponse = {
  items: SidebarItem[];
  folders?: SidebarFolder[];
  views: SidebarView[];
  workspacePages: SidebarWorkspacePageSummary[];
  legacyViewIdByPageId: Record<string, string>;
};

export async function fetchSidebarItems(): Promise<SidebarItemsResponse> {
  return apiFetch<SidebarItemsResponse>("/api/sidebar-items");
}

export async function setSidebarItemFavorite(id: string, isFavorite: boolean): Promise<SidebarItem> {
  const data = await apiFetch<{ item: SidebarItem }>("/api/sidebar-items", {
    method: "PATCH",
    body: JSON.stringify({ action: "favorite", id, isFavorite }),
  });
  return data.item;
}

export async function reorderSidebarItems(ids: string[]): Promise<void> {
  await apiFetch("/api/sidebar-items", {
    method: "PATCH",
    body: JSON.stringify({ action: "reorder", ids }),
  });
}

export type SidebarFolderAction =
  | { action: "create"; title: string }
  | { action: "rename"; id: string; title: string }
  | { action: "icon"; id: string; icon: string | null }
  | { action: "delete"; id: string }
  | { action: "move"; pageId: string; folderId: string | null };

export function updateSidebarFolders(action: SidebarFolderAction): Promise<{ folders: SidebarFolder[]; createdId?: string }> {
  return apiFetch("/api/sidebar-folders", { method: "PATCH", body: JSON.stringify(action) });
}
